module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "charts-box-copy-lpie-census"
    }
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18f02b92"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/charts/census.vue
// module id = 1769
// module chunks = 9